import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-5xl font-bold mt-12 mb-8 max-w-xl mx-auto" }, " Send a message 👋 ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl" }, " Send a message and it'll be stored in the blockchain! ", -1)
const _hoisted_4 = {
  key: 0,
  class: "my-8"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" People have sent ")
const _hoisted_6 = { class: "text-indigo-500 font-bold" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" messages so far ")
const _hoisted_8 = {
  key: 1,
  class: "my-8 text-red-500 font-medium"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "my-4 font-medium" }, " Note: This app works using the Rinkeby blockchain ", -1)
const _hoisted_10 = { class: "flex flex-col max-w-md mx-auto space-y-4 mt-8" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 font-bold" }, "All messages 📩", -1)
const _hoisted_15 = { class: "flex flex-col max-w-md my-8 mx-auto" }
const _hoisted_16 = { class: "text-left" }
const _hoisted_17 = { class: "font-bold" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" said: ")
const _hoisted_19 = { class: "italic" }
const _hoisted_20 = { class: "text-sm mt-4 text-right" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (_ctx.walletStore.walletData != null)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.totalWaves), 1),
          _hoisted_7
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_8, " You have to connect your wallet first! ")),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message) = $event)),
        disabled: _ctx.walletStore.walletData == null,
        cols: "30",
        rows: "5",
        class: _normalizeClass(["border ring-none text-pink-600 font-medium rounded p-2", 
          _ctx.walletStore.walletData == null
            ? 'border-gray-200 text-gray-400'
            : 'border-pink-500 text-pink-600 hover:shadow-lg shadow-sm'
        ])
      }, null, 10, _hoisted_11), [
        [_vModelText, _ctx.message]
      ]),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args))),
        disabled: _ctx.walletStore.walletData == null || _ctx.trxInProgress,
        class: _normalizeClass(["px-4 py-2 mt-8 border font-medium rounded", 
          _ctx.walletStore.walletData == null
            ? 'border-gray-200 text-gray-400'
            : 'border-pink-500 text-pink-600 hover:shadow-lg shadow-sm'
        ])
      }, _toDisplayString(_ctx.trxInProgress ? `Sending...` : `Send message 👋`), 11, _hoisted_12),
      _hoisted_13,
      _hoisted_14,
      _createElementVNode("ul", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allMessages, (msg) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "p-4 border mt-2 rounded-lg",
            key: msg
          }, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", null, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(msg.from.slice(0, 2)) + "..." + _toDisplayString(msg.from.slice(-4)), 1),
                _hoisted_18
              ]),
              _createElementVNode("blockquote", _hoisted_19, _toDisplayString(msg.text), 1)
            ]),
            _createElementVNode("p", _hoisted_20, "posted on " + _toDisplayString(msg.datetime), 1),
            _hoisted_21
          ]))
        }), 128))
      ])
    ])
  ]))
}